/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
import {
  Box,
  Button,
  Collapse,
  IconButton,
  Paper,
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Tooltip,
  Typography
} from '@mui/material';
import PurchaseDialog from './PurchaseDialog';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getPurchaseApi } from '../../../api/stocks/purchases/purchasesApi';
import { Delete, Edit } from '@mui/icons-material';
import AddIcon from '@mui/icons-material/Add';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import { TopBox } from '../../Shared/shared';

export default function Purchase() {
  const [openDialog, setOpenDialog] = useState({ isOpen: false, id: '' });

  const params = useParams();
  const obj = params;
  const outletstr = obj['*']; // gets the string "outlet/skp/pos"
  const str = outletstr;
  const parts = str.split('/');
  const code = parts[1]; // gets the text "skp"

  const outlet = useSelector((state) =>
    state.authorize?.loginResponse?.user?.outlets?.find(
      (outlet) => outlet.code.toLowerCase() === code
    )
  );

  const [purchaseData, setPurchaseData] = useState([]);

  const getPurchase = async () => {
    const res = await getPurchaseApi(outlet._id);
    setPurchaseData(res.data);
  };

  // handling inner tables
  const [openRows, setOpenRows] = useState(
    Array(purchaseData.length).fill(false)
  );

  const handleRowClick = (index) => {
    const newOpenRows = [...openRows];
    newOpenRows[index] = !newOpenRows[index];
    setOpenRows(newOpenRows);
  };

  // pagination
  const [pg, setpg] = React.useState(0);
  const [rpg, setrpg] = React.useState(20);

  function handleChangePage(event, newpage) {
    setpg(newpage);
  }

  function handleChangeRowsPerPage(event) {
    setrpg(parseInt(event.target.value, 10));
    setpg(0);
  }

  const callFunc = () => {
    getPurchase();
  };

  useEffect(() => {
    getPurchase();
  }, []);

  return (
    <>
      <TopBox>
        <Typography sx={{ fontSize: '20px', fontWeight: 700 }}>
          Purchase Managment
        </Typography>
        <Tooltip title="Add New Purchase">
          <Button
            style={{
              backgroundColor: '#66C8E0',
              padding: ' 10px 30px'
            }}
            onClick={() => {
              setOpenDialog({ isOpen: true });
            }}>
            <AddIcon />
            <Typography sx={{ lineHeight: '0', letterSpacing: '0' }}>
              Add Purchase
            </Typography>
          </Button>
        </Tooltip>
      </TopBox>

      {!purchaseData ? (
        <Box
          sx={{
            height: 'max-content'
          }}>
          {[...Array(10)].map((arr, i) => (
            <Skeleton key={i} variant="rectangular" sx={{ my: 4, mx: 1 }} />
          ))}
        </Box>
      ) : (
        <TableContainer component={Paper}>
          <Table aria-label="collapsible table">
            <TableHead sx={{ background: '#66C8E0', color: 'white' }}>
              <TableRow>
                <TableCell>
                  <RemoveRedEyeIcon />
                </TableCell>
                <TableCell>User</TableCell>
                <TableCell>Supplier</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Sale Date</TableCell>
                <TableCell>Description</TableCell>
                <TableCell>Paid Amount</TableCell>

                <TableCell align="center">Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {purchaseData
                ?.slice(pg * rpg, pg * rpg + rpg)
                .map((singleSet, index) => {
                  return (
                    <React.Fragment key={index}>
                      <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
                        <TableCell>
                          <IconButton
                            aria-label="expand row"
                            width="0px"
                            size="small"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleRowClick(index);
                            }}>
                            {openRows[index] ? (
                              <KeyboardArrowUpIcon />
                            ) : (
                              <KeyboardArrowDownIcon />
                            )}
                          </IconButton>
                        </TableCell>
                        <TableCell>{singleSet.user.name}</TableCell>
                        <TableCell>{singleSet.supplier.name}</TableCell>
                        <TableCell>
                          {singleSet.active == true ? 'Active' : 'In Active'}
                        </TableCell>
                        <TableCell>{singleSet.saleDate}</TableCell>
                        <TableCell sx={{ maxWidth: '110px' }}>
                          <Tooltip
                            title={
                              <Typography fontSize={15}>
                                {singleSet.desc}
                              </Typography>
                            }
                            placement="top">
                            <Typography
                              sx={{
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap',
                                fontSize: '12px'
                              }}>
                              {singleSet.desc}
                            </Typography>
                          </Tooltip>
                        </TableCell>
                        <TableCell>{singleSet?.paidAmount}</TableCell>
                        <TableCell
                          sx={{ display: 'flex', justifyContent: 'center' }}>
                          <Button
                            sx={{ color: '#66C8E0' }}
                            onClick={() => {
                              setOpenDialog({
                                isOpen: true,
                                id: singleSet._id
                              });
                            }}>
                            <Edit />
                          </Button>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell
                          style={{ paddingBottom: 0, paddingTop: 0 }}
                          colSpan={6}>
                          <Collapse
                            in={openRows[index]}
                            timeout="auto"
                            unmountOnExit>
                            <Box sx={{ margin: 1 }}>
                              <Typography
                                variant="h6"
                                gutterBottom
                                component="div">
                                Ingredients
                              </Typography>
                              <Table size="small" aria-label="purchases">
                                <TableHead>
                                  <TableRow>
                                    <TableCell
                                      sx={{
                                        fontWeight: 700,
                                        fontSize: '17px'
                                      }}>
                                      Ingredient
                                    </TableCell>
                                    <TableCell
                                      sx={{
                                        fontWeight: 700,
                                        fontSize: '17px'
                                      }}>
                                      Quantity
                                    </TableCell>
                                    <TableCell
                                      sx={{
                                        fontWeight: 700,
                                        fontSize: '17px'
                                      }}>
                                      Value
                                    </TableCell>
                                    <TableCell
                                      sx={{
                                        fontWeight: 700,
                                        fontSize: '17px'
                                      }}>
                                      Amount
                                    </TableCell>
                                    <TableCell
                                      sx={{
                                        fontWeight: 700,
                                        fontSize: '17px'
                                      }}>
                                      Description
                                    </TableCell>
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  {singleSet.ingredients.map(
                                    (historyRow, index) => {
                                      return (
                                        <TableRow key={index}>
                                          <TableCell>
                                            {historyRow?.ingredient?.name}
                                          </TableCell>
                                          <TableCell>
                                            {historyRow.quantity} <></>
                                            <b>
                                              {
                                                historyRow?.ingredient?.unit
                                                  ?.code
                                              }
                                            </b>
                                          </TableCell>
                                          <TableCell>
                                            {historyRow?.value}
                                          </TableCell>
                                          <TableCell>
                                            {historyRow?.value *
                                              historyRow.quantity}
                                          </TableCell>
                                          <TableCell>
                                            {historyRow.desc}
                                          </TableCell>
                                        </TableRow>
                                      );
                                    }
                                  )}
                                </TableBody>
                              </Table>
                            </Box>
                          </Collapse>
                        </TableCell>
                      </TableRow>
                    </React.Fragment>
                  );
                })}
              <TableRow>
                <TablePagination
                  rowsPerPageOptions={[20, 50, 100]}
                  count={purchaseData?.length || 0}
                  rowsPerPage={rpg}
                  page={pg}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      )}
      <PurchaseDialog
        openDialog={openDialog}
        setOpenDialog={setOpenDialog}
        outletId={outlet?._id}
        callFunc={callFunc}
      />
    </>
  );
}
